var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileCompanyIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44488 0.777344C6.64713 0.777344 6.00043 1.42404 6.00043 2.22179V38.3329H0.222656V41.2218H37.7782V38.3329H32.0004V2.22179C32.0004 1.42404 31.3537 0.777344 30.556 0.777344H7.44488Z",
    fill: "#256AF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.334,
    y: 3.66602,
    width: 5.77778,
    height: 5.77778,
    fill: "#6CCC93"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8887,
    y: 3.66602,
    width: 5.77778,
    height: 5.77778,
    fill: "#6CCC93"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.334,
    y: 12.332,
    width: 5.77778,
    height: 5.77778,
    fill: "#6CCC93"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8887,
    y: 12.332,
    width: 5.77778,
    height: 5.77778,
    fill: "#6CCC93"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.334,
    y: 21,
    width: 5.77778,
    height: 5.77778,
    fill: "#6CCC93"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8887,
    y: 21,
    width: 5.77778,
    height: 5.77778,
    fill: "#6CCC93"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1113,
    y: 29.666,
    width: 5.77778,
    height: 8.66667,
    fill: "#6CCC93"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCompanyIc);
export default __webpack_public_path__ + "static/media/profile-company-ic.7befbaa373161eeb7786e3c8c30b6234.svg";
export { ForwardRef as ReactComponent };